module.exports = __webpack_public_path__ + "static/img/6_3.97d92ce8.jpg";